import { Button, Input, Modal } from 'antd'
import { useEffect, useState } from 'react'
import {
  setGraphRenameRelationProps
} from 'Actions/graph'
import { useDispatch } from 'react-redux'

export default ({ data }) ->
  dispatch = useDispatch()

  [relKey, setRelKey] = useState(undefined)

  useEffect(->
    if data?
      setRelKey(data.key)
  , [data])

  rename = ->
    data.promise.resolve({
      key: relKey
    })

  Footer =
    <Button
      type="primary"
      onClick={rename}
    >
      Rename
    </Button>

  close = ->
    dispatch(setGraphRenameRelationProps(undefined))

  <Modal
    title='Rename relation'
    visible={data?}
    onCancel={close}
    centered={true}
    mask={false}
    destroyOnClose={true}
    footer={Footer}
  >
    <Input
      value={relKey}
      onChange={(e) ->
        setRelKey(e.target.value)
      }
      placeholder='Relation key'
    />
  </Modal>
